
export const pageTitleDefault = `Citizen Music | An exceptional production music library for advertising`;
export const pageTitleAbout = `Citizen Music About | Why we're crafting exceptional music for advertising`;


// WEBPACK FOOTER //
// ./src/constants.js